// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__22Wik","overflowing":"ReadFullNote_overflowing__2dggj"};